import { tiendasApi } from '../api'

export const formularioSuscripcionApiSlice = tiendasApi.injectEndpoints({
    endpoints: (builder) => ({

        // --- 1. LECTURAS (QUERIES) ---
        
        getPaginatedFormularios: builder.query({
            query: ({ page = 1, textsearch = '', orderParams = [1, 1], estado = 'todos' }) => ({
                url: 'formulario-suscripcion',
                method: 'GET',
                params: {
                    page,
                    textsearch,
                    order: orderParams,
                    estado
                }
            }),
            // Usamos _id para coincidir con la respuesta de MongoDB
            providesTags: (result) =>
                result && result.docs
                    ? [
                        ...result.docs.map(({ _id }) => ({ type: 'Formulario', id: _id })),
                        { type: 'Formulario', id: 'LIST' }
                    ]
                    : [{ type: 'Formulario', id: 'LIST' }],
        }),

        getFormularioById: builder.query({
            query: (id) => ({
                url: `formulario-suscripcion/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'Formulario', id }],
        }),


        // --- 2. MUTACIONES (POST, PUT, DELETE) ---

        createFormularioSuscripcion: builder.mutation({
            query: (body) => ({
                url: 'formulario-suscripcion',
                method: 'POST',
                body, // { titulo, desde, hasta, importe }
            }),
            // Al crear uno nuevo, invalidamos la lista entera para forzar un refetch de la tabla
            invalidatesTags: [{ type: 'Formulario', id: 'LIST' }],
        }),

        updateFormularioSuscripcion: builder.mutation({
            // Desestructuramos el id para la URL y pasamos el resto como body
            query: ({ id, ...body }) => ({
                url: `formulario-suscripcion/${id}`,
                method: 'PUT',
                body, // { titulo, desde, hasta, importe }
            }),
            // Invalidamos el ID específico para actualizar vistas de detalle, y la LIST para la tabla
            invalidatesTags: (result, error, { id }) => [
                { type: 'Formulario', id },
                { type: 'Formulario', id: 'LIST' }
            ],
        }),

        deleteFormularioSuscripcion: builder.mutation({
            query: (id) => ({
                url: `formulario-suscripcion/${id}`,
                method: 'DELETE',
            }),
            // Al eliminar, la lista cambia, así que forzamos un refetch
            invalidatesTags: [{ type: 'Formulario', id: 'LIST' }],
        }),

    }),
    overrideExisting: false,
})

export const {
    useGetPaginatedFormulariosQuery,
    useLazyGetPaginatedFormulariosQuery,
    useGetFormularioByIdQuery,
    useLazyGetFormularioByIdQuery,
    useCreateFormularioSuscripcionMutation,
    useUpdateFormularioSuscripcionMutation,
    useDeleteFormularioSuscripcionMutation,
} = formularioSuscripcionApiSlice